import { IMAGE_CDN } from "../constants/constants";

const env = import.meta.env.MODE;

export function getImage(name) {
  if (env === 'development') {
    return `/images/${name}`
  } else {
    return `${IMAGE_CDN}/${name}`
  }
}
